import { PHONE, locationSchema } from "../structured-data-core";

export function getNewportBeachStructuredData() {
  const url = "https://restorehair.com/locations/california/newport-beach/";
  const description =
    "Find out about your hair transplant options in Newport Beach with RESTORE Hair. Over 20,000 procedures performed.";
  return [
    locationSchema("Newport Beach", "4040 MacArthur Boulevard, Suite 305", "Newport Beach", "CA", PHONE, url, description),
  ];
}
